import { defineMessages } from 'react-intl'

import { CLASSES } from './constants'

export const classMessages = defineMessages({
  [CLASSES.ECONOMICO]: {
    id: 'dictionary.economico',
    defaultMessage: 'Económico'
  },
  [CLASSES.PRIMERA]: {
    id: 'dictionary.primera',
    defaultMessage: 'Primera'
  },
  [CLASSES.LUJO]: {
    id: 'dictionary.lujo',
    defaultMessage: 'Lujo'
  }
})
